module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    attrs: {
      "id": "application"
    }
  }, [_c('div', {
    attrs: {
      "id": "notification-panel"
    }
  }, [_c('transition-group', {
    attrs: {
      "name": "fade"
    }
  }, _vm._l((_vm.notificationsStore.notifications), function(n, i) {
    return _c('notification', {
      key: n.title,
      attrs: {
        "notification": n
      }
    })
  }), 1)], 1), (_vm.title && _vm.title != '') ? _c('div', {
    staticClass: "upperBar"
  }, [_vm._v(_vm._s(_vm.title))]) : _vm._e(), _c('router-view'), _c('div', {
    attrs: {
      "id": "global-modal-container"
    }
  })], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-cc235ee6!./~/vue-loader/lib/template-loader.js?raw&engine=pug!./~/vue-loader/lib/selector.js?type=template&index=0!./src/App.vue
// module id = 2625
// module chunks = 1